export default {
  title: 'Syötä hyvityssumma',
  description: 'Hyvitettävissä: {{amount}}',
  form: {
    amount: {
      label: 'Hyvitä',
    },
    reason: {
      label: 'Syy',
      options: {
        requested_by_customer: 'asiakkaan pyynnöstä',
        reclamation: 'reklamaatio',
        communication_error: 'viestintävirhe',
        other: 'muu',
      },
    },
    manual_reason: {
      label: 'Syötä hyvityksen syy',
    },
  },
  feedback: {
    amount_too_small: 'Hyvityksen vähimmäismäärä {{amount}}',
    amount_too_big: 'Hyvityksen enimmäismäärä {{amount}}',
    payment_frozen: 'Hyvitystä on jo pyydetty asiakkaalta. {{provider}} on yhteydessä asiakkaaseen hyvityksen osalta',
  },
  buttons: {
    refund: 'Hyvitä',
    cancel: 'Peruuta',
  },
  toasts: {
    refund_successful: '{{amount}} hyvitys aloitettiin onnistuneesti!',
  },
};
